export default __webpack_public_path__ + "static/media/switch_chat_channel.5eca05a1.svg";